import React from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { FullWidthWrapper, Container } from '../../Container/Container.style'
import { TabContainer } from './TabsContainer.style'
import ProductCarousel from '../ProductCarousel'

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
}

const TabsContainer = ({ title, description, tabs, backgroundImage }) => (
  <FullWidthWrapper
    className="tabContainer"
    style={{
      backgroundImage: `url(${backgroundImage &&
            backgroundImage.file.url})`,
      backgroundSize: 'cover',
    }}
  >
    <Container>
      <TabContainer>
        <h3>{title}</h3>
        {description && (
          <div
            className="tabCopy"
            dangerouslySetInnerHTML={{
              __html: description.childMarkdownRemark.html,
            }}
          />
        )}

        <Tabs className="productTabs">
          <TabList className="tabs">
            { tabs &&
                  tabs.map(tabData => {
                    return (
                      <Tab
                        key={tabData.id}
                      >
                        {tabData.tabHeading}
                      </Tab>
                    )
                  })}
          </TabList>
          { tabs &&
            tabs.map(tabData => {
              return (
                <TabPanel key={tabData.id} onClick={event => event.stopPropagation()}>
                  {
                    tabData.tabContent && (
                      <ProductCarousel
                        settings={settings}
                        products={tabData.tabContent.products}
                        productBackgroundImage={tabData.tabContent.productBackgroundImage}
                      />
                    )
                  }
                </TabPanel>
              )
            })}
        </Tabs>
      </TabContainer>
    </Container>
  </FullWidthWrapper>
)

export default TabsContainer

TabsContainer.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    tabHeading: PropTypes.string.isRequired,
    productBackgroundImage: PropTypes.shape({
      file: PropTypes.shape({
        url: PropTypes.string.isRequired,
      }),
    }),
    tabContents: PropTypes.shape().isRequired,
  })).isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.shape({
    childMarkdownRemark: PropTypes.shape({
      html: PropTypes.string.isRequired,
    }),
  }),
  backgroundImage: PropTypes.shape({
    file: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }),
  }),
}

TabsContainer.defaultProps = {
  description: null,
  backgroundImage: null,
}

export const TabsContainerFragment = graphql`
  fragment TabsContainerFragment on ContentfulTabsContainer {
    id
    title
    description {
      childMarkdownRemark {
        html
      }
    }
    backgroundImage {
      file {
        url
      }
    }
    tabs {
      id
      tabHeading
      tabContent {
        ...ProductCarouselFragment
      }
    }
  }
`
